module.exports = __webpack_public_path__ + "static/whois-domain-lookup-61eaeaec564d3aff7bdaea3dcbd9599a.png";